import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

import { PermitStatus } from '../../../models/permit-status.model';

export interface PermitStatusMigrateDialogData {
    source: PermitStatus;
    targets: PermitStatus[];
}

@Component({
    selector: 'app-permit-status-migrate-dialog',
    templateUrl: './permit-status-migrate-dialog.component.html',
    styleUrls: ['./permit-status-migrate-dialog.component.scss'],
})
export class PermitStatusMigrateDialogComponent {
    targetId: string | null = null;

    constructor(
        private dialogRef: MatDialogRef<PermitStatusMigrateDialogComponent>,
        private translate: TranslateService,
        @Inject(MAT_DIALOG_DATA) public data: PermitStatusMigrateDialogData,
    ) {}

    statusName(status: PermitStatus): string {
        const { name } = status;
        if (!name) return '';
        if (typeof name === 'string') return name;
        const lang = this.translate.currentLang || 'fr';
        return name[lang] || name.fr || name.en || '';
    }

    confirm(): void {
        if (!this.targetId) return;
        this.dialogRef.close(this.targetId);
    }

    cancel(): void {
        this.dialogRef.close();
    }
}
